import { RootState } from "../rootReducer";
import { getPersistData, setPersistData } from "../utils/utils";
import * as DYNAMIC_FORM_ACTION_TYPES from "../components/DynamicForm/actionTypes";
import * as PAYMENT_ACTION_TYPES from "../components/ThankYou/actionTypes";

import { TransactionData } from "../components/ThankYou/reducer";

export interface PersistData {
    isAlreadyPaymentInitiated?: boolean;
    warrantyId?: number;
    forminstanceTypeId?: number;
    contractorId?: number;
    customerId?: any;
    shoppingCartId?: any;
    warrantyReceivedDate?: string;
    forceSaveWarranty?: boolean;
}

/**
 * Redux Middleware
 * Use to handle PersistData from Localstorage
 * @param getState
 * @category Middleware
 */
const persistDataMiddleware = ({ getState }) => (next) => (action) => {
    let result;
    let persistData: PersistData = getPersistData() || {};
    const state: RootState = getState();

    switch (action.type) {
        case DYNAMIC_FORM_ACTION_TYPES.FETCH_SAVED_FORM_LAYOUT_DATA_SUCCESS:
            result = next(action);
            if (persistData.isAlreadyPaymentInitiated) {
                persistData = Object.assign(persistData, { isAlreadyPaymentInitiated: false });
                setPersistData(persistData);
            }
            return result;
        case PAYMENT_ACTION_TYPES.UPDATE_NAVIGATION:
            const transactionData: TransactionData = action.payload;
            const warrantyId = state.dynamicFormInfo.warrantyId;
            const forminstanceTypeId = state.dynamicFormInfo.layoutResponse.forminstanceTypeId;
            if (transactionData.proceedToPayment) {
                persistData = Object.assign(persistData, {
                    isAlreadyPaymentInitiated: true,
                    warrantyId,
                    forminstanceTypeId,
                    contractorId:
                        state.adminData.contractorSelection && state.adminData.contractorSelection.contractorId,
                    customerId: state.adminData.contractorSelection && state.adminData.contractorSelection.customerId,
                });
                setPersistData(persistData);
            }
            result = next(action);
            return result;
        case PAYMENT_ACTION_TYPES.UPDATE_TRANSACTION_DATA:
        case PAYMENT_ACTION_TYPES.UPDATE_ALREADY_PAYMENT_INITIATED:
            persistData = Object.assign(persistData, { isAlreadyPaymentInitiated: false });
            setPersistData(persistData);
            result = next(action);
            return result;
        case PAYMENT_ACTION_TYPES.ADD_CONTRACTOR_ID_FROM_PERSIST:
            persistData = Object.assign(persistData, {
                ...persistData,
                contractorId: action.contractorId,
                customerId: state.adminData.contractorSelection && state.adminData.contractorSelection.customerId,
            });
            setPersistData(persistData);
            result = next(action);
            return result;
        case PAYMENT_ACTION_TYPES.REMOVE_CONTRACTOR_ID_FROM_PERSIST:
            delete persistData.contractorId;
            delete persistData.customerId;
            setPersistData(persistData);
            result = next(action);
            return result;
        default:
            result = next(action);
            return result;
    }
};

export default persistDataMiddleware;
